/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Fit_LeftInputs */

const en_directory_comparison_product_hunt_rows_fit_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Fit_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want a maintained directory presence`)
};

const zh_directory_comparison_product_hunt_rows_fit_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Fit_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要可持续维护的目录页面`)
};

/**
* | output |
* | --- |
* | "You want a maintained directory presence" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Fit_LeftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_fit_left = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Fit_LeftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Fit_LeftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_fit_left(inputs)
	return zh_directory_comparison_product_hunt_rows_fit_left(inputs)
});
export { directory_comparison_product_hunt_rows_fit_left as "directory.comparison.product_hunt.rows.fit.left" }